/**
 * Suppliers.order_item_sort: how an order's lines are numbered (sort_order / item_no) every time
 * the API renumbers them (after each totals calculation: order entry, cart checkout, imports, API).
 * null = manual: lines keep the sequence they were added in and drag reordering sticks. With a value
 * set, top-level lines are re-sorted and kit children stay under their parent; the order screen,
 * PDFs and the QuickBooks Desktop push all follow the stored order.
 */
enum OrderItemSortEnum {
    /** Warehouse pick path: Catalog_Item.row, then bin (natural sort, blanks last), then SKU, then name. Items with no row/bin last. */
    ROW_BIN = "row_bin",
    /** Alphanumeric: Catalog_Item.sku (natural sort), then name. */
    SKU = "sku",
}

export default OrderItemSortEnum;
